// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2FgAY","col":"CardReaderDesc_col__2APPx","label":"CardReaderDesc_label__2-9rp"};